module.exports = __webpack_public_path__ + "static/media/1.79205f28.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_41/images/九宫格未选中态/1.png
// module id = 941
// module chunks = 0